import ApiBase from '@/sag-core/base/ApiBase'
import https from '@/apis/https.js'
import { filePost } from '@/apis/https.js'
import tools from '@/sag-core/tools'
import store from '@/store'
//取得所有產線

let api = null
api = tools.mergeDeep(new ApiBase(), {
    GetSpecDeadLine(){
        return https({
            url: 'https://eip2.sag.tw/SAGVueFrameApi/BookMeal/GetSpecDeadLine',
            data: null,
            method: 'post'
        })
    },

    GetDateLock(){
        return https({
            url: 'https://eip2.sag.tw/SAGVueFrameApi/BookMeal/GetDateLock',
            data: null,
            method: 'post'
        })
    },
    
    /**
     * 午餐梯次
     */
    GetMealSequence(WorkCode){
        return https({
            url: 'https://eip2.sag.tw/SAGVueFrameApi/BookMeal/GetMealSequence',
            data: {
                WorkCode
            },
            method: 'post'
        })
    },

    /**
     * 指定日餐點
     * @param {Date} date
     */
    GetMealDate(date){
        return https({
            url: 'https://eip2.sag.tw/SAGVueFrameApi/BookMeal/GetMealDate',
            data: {
                date
            },
            method: 'post'
        })
    },

    TestClearMealOrder(){
        return https({
            url: 'https://eip2.sag.tw/SAGVueFrameApi/BookMeal/TestClearMealOrder',
            method: 'post'
        }) 
    },

    TestSendMail(date, mailto){
        return https({
            url: 'https://eip2.sag.tw/SAGVueFrameApi/BookMeal/TestSendMail',
            data: {
                date,
                mailto,
            },
            method: 'post'
        }) 
    },

    Import(file){
        return filePost({
            url: 'https://eip2.sag.tw/SAGVueFrameApi/BookMeal/Import',
            method: 'post',
            file: file,
        })
    },

    /**
     * 更新訂餐
     */
    PostOrder(data){
        return https({
            url: 'https://eip2.sag.tw/SAGVueFrameApi/BookMeal/PostOrder',
            data,
            method: 'post'
        })
    },
    /**
     * 取得範圍期間菜單
     * @param {Date} sdate
     * @param {Date} edate
     */
    GetMealDaily(sdate, edate){
        return https({
            url: 'https://eip2.sag.tw/SAGVueFrameApi/BookMeal/GetMealDaily',
            data: {
                sdate,
                edate,
            },
            method: 'post'
        })
    },

    /**
     * 新增訂餐
     */
    InsertOrder(data){
        return https({
            url: 'https://eip2.sag.tw/SAGVueFrameApi/BookMeal/InsertOrder',
            data,
            method: 'post'
        })
    },

    /**
     * 刪除訂餐
     */
    DeleteOrder(data){
        return https({
            url: 'https://eip2.sag.tw/SAGVueFrameApi/BookMeal/DeleteOrder',
            data,
            method: 'post'
        })
    },

    /**
     * 取得訂餐
     */
    GetOrder(data){
        return https({
            url: 'https://eip2.sag.tw/SAGVueFrameApi/BookMeal/GetOrder',
            data,
            method: 'post'
        })
    },
})

if(store.state.webConfig.apiTest){
    api = tools.mergeDeep(new ApiBase(), {
        GetSpecDeadLine(){
            return https({
                url: 'http://localhost:12345/BookMeal/GetSpecDeadLine',
                data: null,
                method: 'post'
            })
        },

        GetDateLock(){
            return https({
                url: 'http://localhost:12345/BookMeal/GetDateLock',
                data: null,
                method: 'post'
            })
        },

        /**
         * 午餐梯次
         */
        GetMealSequence(WorkCode){
            return https({
                url: 'http://localhost:12345/BookMeal/GetMealSequence',
                data: {
                    WorkCode
                },
                method: 'post'
            })
        },

        /**
         * 指定日餐點
         * @param {Date} date
         */
        GetMealDate(date){
            return https({
                url: 'http://localhost:12345/BookMeal/GetMealDate',
                data: {
                    date
                },
                method: 'post'
            })
        },

        TestClearMealOrder(date, mailto){
            return https({
                url: 'http://localhost:12345/BookMeal/TestClearMealOrder',
                method: 'post'
            }) 
        },

        TestSendMail(date, mailto){
            return https({
                url: 'http://localhost:12345/BookMeal/TestSendMail',
                data: {
                    date,
                    mailto,
                },
                method: 'post'
            }) 
        },

        Import(file){
            return filePost({
                url: 'http://localhost:12345/BookMeal/Import',
                method: 'post',
                file: file,
            })
        },

        /**
         * 取得範圍期間菜單
         * @param {Date} sdate
         * @param {Date} edate
         */
        GetMealDaily(sdate, edate){
            return https({
                url: 'http://localhost:12345/BookMeal/GetMealDaily',
                data: {
                    sdate,
                    edate,
                },
                method: 'post'
            })
        },

        /**
         * 新增訂餐
         */
        InsertOrder(data){
            return https({
                url: 'http://localhost:12345/BookMeal/InsertOrder',
                data,
                method: 'post'
            })
        },

        /**
         * 刪除訂餐
         */
        DeleteOrder(data){
            return https({
                url: 'http://localhost:12345/BookMeal/DeleteOrder',
                data,
                method: 'post'
            })
        },

        /**
         * 取得訂餐
         */
        GetOrder(data){
            return https({
                url: 'http://localhost:12345/BookMeal/GetOrder',
                data,
                method: 'post'
            })
        },

        /**
         * 更新訂餐
         */
        PostOrder(data){
            return https({
                url: 'http://localhost:12345/BookMeal/PostOrder',
                data,
                method: 'post'
            })
        }
    })
}

export default api